import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  root: {
    minHeight: '100%',
    height: 'inherit',
    overflow: 'auto',
    backgroundColor: 'grey.100',
    display: 'flex',
    flexDirection: 'column',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    px: 3,
    flex: 1,
  },
  content: {
    flexBasis: '100%',
    maxWidth: '100%',
    minWidth: '1px',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    py: '8px',
  },
  breadcrumbsWrapper: {
    ml: -0.5,
    mt: 0,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 0,
    gap: 1,
  },
  exportPdfMessageRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    mb: 1.5,
  },
  pdfDownloadMessage: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
    flexShrink: 1,
    minWidth: '0px',
  },
  spinner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
    fontSize: '12px',
    mr: 1,
  },
  publicationContainer: {
    mx: 3,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
});
